import { Icon } from "@xapp/components";
import { SystemNotification, SystemNotificationLevel } from "generated/graphql";
import React, { FC } from "react";
import styles from "./AppNotification.scss";
import { IconType } from "@xapp/components/dist/types/icon.types";

export type AppNotificationType = Pick<SystemNotification, "id" | "message" | "level">;

export interface AppNotificationProps {
    readonly notification?: AppNotificationType;
    readonly type: "recomendation" | "notification";
    readonly value?: string;
}

function getIconType(level: SystemNotificationLevel): IconType | undefined {
    switch (level) {
        case SystemNotificationLevel.Info:
            return "notifications";
        case SystemNotificationLevel.Warn:
            return "warning";
        case SystemNotificationLevel.Error:
            return "priority_high";
        default:
            return undefined;
    }
}
export const AppNotification: FC<AppNotificationProps> = props => {
    const { notification, type, value } = props;

    const icon = type === "notification" ? getIconType(notification.level) : "try";

    return (
        <div className={styles.notification}>
            <div className={styles.side}>
                <div className={styles.icon}>
                    {icon && <Icon iconName={icon} />}
                </div>
            </div>
            <div className={styles.content}>{type === "notification" ? notification.message : value}</div>
        </div>
    );
};